import { BusinessResponses } from '@luxuryescapes/contract-business'
import requestUtils from 'api/requestUtils'

interface InvitationResendRequest {
  email: string
}

async function requestInvitationResend(email: string): Promise<BusinessResponses.BaseResponse<boolean>> {
  return await requestUtils.post<BusinessResponses.BaseResponse<boolean>, InvitationResendRequest>('/api/business-traveller/employees/request-invitation-resend', { email })
}

export default requestInvitationResend
